<template>

    <form ref="estagioconteudo-form-edit" v-on:submit.prevent="executeEdit(model)" novalidate>

        <div class="row">
            <div class="form-group col-md-12">
                <label for="conteudo">Conteúdo</label>
                <input type="text" class="form-control" maxlength="255" name="conteudo" placeholder="Conteúdo" v-model="model.conteudo" required />
            </div>
            <div class="form-group col-md-3">
                <label for="tempo">Tempo</label>
                <input type="number" class="form-control" min="0" name="tempo" placeholder="Tempo" v-model="model.tempo" required />
            </div>
            <div class="form-group col-md-3">
                <label for="ordem">Ordem</label>
                <input type="number" class="form-control" min="0" name="ordem" placeholder="Ordem" v-model="model.ordem" required />
            </div>

            <div class="form-group col-md-6">
                <div class="clearfix">&nbsp;</div>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="ehAvaliacao" class="custom-control-input" v-model="model.ehAvaliacao">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"> Avaliação?</span>
                </label>
                <label v-if="this.autoAjudaVisivel" class="custom-control custom-checkbox">
                    <input type="checkbox" name="ehAssincrona" class="custom-control-input" v-model="model.ehAssincrona">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"> Aula de Auto Estudo?</span>
                </label>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="eAdicional" class="custom-control-input" v-model="model.eAdicional">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"> É conteúdo adicional?</span>&nbsp;
                    <span v-b-tooltip.hover title="Os conteúdos marcados como adicionais serão aplicados somente nos planos de aulas de turmas CNA Conecta, cadastradas na Digital School.">
                        <i class="fa fa-info-circle"></i>
                    </span>
                </label>
            </div>

        </div>

        <button type="button" class="btn btn-default" @click="onBack()">
            <span>Voltar</span>
        </button>
        <button type="button" class="btn btn-success float-right" @click="executeEdit(model)">
            <span>Salvar</span>
        </button>

    </form>


</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "estagioconteudo-form-edit",
        mixins: [base],
        props: { id: Number },
        data: () => ({
            autoAjudaVisivel: false,
            model: {},

            form: "estagioconteudo-form-edit",

            resources: {
                edit: 'estagioconteudo',
            },

        }),

        methods: {

            executeEdit: function (model) {

                if (this.formValidate() == false) return;

                new Api(this.resources.edit).put(model).then(data => {
                    this.defaultSuccessResult("Edição realizada com sucesso");
                    this.$emit('on-saved', data)
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },

            onBack: function () {
                this.$emit('on-back')
            }
        },

        mounted() {
            if (this.$route.params.id == 370 || this.$route.params.id == 371 || this.$route.params.id == 372 || this.$route.params.id == 373) {               
                this.autoAjudaVisivel = true;
            }
            new Api(this.resources.edit).get({ estagioConteudoId: this.id }).then(data => {
                if (data.data) this.model = data.data;
                else if (!data.dataList) this.model = {};
                else if (data.dataList.length == 1) this.model = data.dataList[0];
                else this.model = {};
            }, err => {
                this.defaultErrorResult(err);
            })
        }
    };
</script>